import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';

import { modalDetailPromoText } from 'Const/stock-promo/view';
import { TextBold, TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import MemoizedTableComponent from 'UiKit/table-component';

import { useStockPromoState } from 'View/stock-promo/state';
import BadgeEcomerce from 'Component/badge-ecommerce';
import tableList from './const';

import styles from './styles.module.css';

const DetailPromoModal = () => {
  const { isOpenModalDetailPromo, detailPromoData, updateState } = useStockPromoState();

  const handleCloseModal = () => {
    updateState({ isOpenModalDetailPromo: false, detailPromoData: null });
  };

  return (
    <Modal isOpen={isOpenModalDetailPromo} onClose={handleCloseModal} isCentered>
      <ModalOverlay />
      <ModalContent minWidth={'1200px'}>
        <ModalHeader>
          <TextBold className={styles['modal__text--title']}>{modalDetailPromoText.title}</TextBold>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody className={styles['modal__section--content']}>
          <Box className={styles['modal__section--promo']}>
            <TextSemiBold className={styles['modal__text--promo-name']}>{detailPromoData?.name}</TextSemiBold>
            <Box className={styles['modal__row--product']}>
              <Box className={styles['modal__column--periode']}>
                <TextRegular className={styles['modal__text--label']}>{modalDetailPromoText.periode}</TextRegular>
                <TextMedium className={styles['modal__text--value']}>{detailPromoData?.promoPeriod}</TextMedium>
              </Box>
              <Box className={styles['modal__column--brand']}>
                <TextRegular className={styles['modal__text--label']}>{modalDetailPromoText.shop}</TextRegular>
                <BadgeEcomerce ecommerce={detailPromoData?.ecommerce} accountName={detailPromoData?.brand} />
              </Box>
            </Box>
          </Box>
          <Box className={styles['modal__section--promo-list']}>
            <MemoizedTableComponent
              columns={tableList}
              containerClassName={styles['modal__table--container']}
              dataSource={detailPromoData?.promotionProducts}
              isDataExist={detailPromoData?.promotionProducts?.length > 0}
              rowHeight="fit-content"
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DetailPromoModal;
